import { render, staticRenderFns } from "./DialogBoxFullscreen.vue?vue&type=template&id=03ddc266&scoped=true"
import script from "./DialogBoxFullscreen.vue?vue&type=script&lang=ts"
export * from "./DialogBoxFullscreen.vue?vue&type=script&lang=ts"
import style0 from "./DialogBoxFullscreen.vue?vue&type=style&index=0&id=03ddc266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ddc266",
  null
  
)

export default component.exports